import React, { Suspense } from 'react';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { initSentry } from "./shared/technical/errors/sentry";
import { reportVersion } from "./shared/technical/logging/versions";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./shared/technical/style/theme";
import { CssBaseline } from "@mui/material";
import { CenteredCircularProgress } from "./shared/components/progress/CenteredCircularProgress";
import ErrorBoundary from "./shared/technical/errors/ErrorBoundary";
import { UserManagerProvider } from "./shared/technical/auth/UserManagerContext";
import { MyRouter } from "./shared/components/router/MyRouter";
import { initI18n } from "./shared/technical/i18n/i18n";
import { ConfigProvider } from "./shared/technical/config/ConfigProvider";
import i18n from "i18next";
import { I18nextProvider } from "react-i18next";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { createRoot } from 'react-dom/client';
import { Settings } from "luxon";

reportVersion();
initSentry();
initI18n();
Settings.defaultZone = "system";

const container = document.getElementById('root')!!;
const root = createRoot(container);
root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <Suspense fallback={<CenteredCircularProgress />}>
      <I18nextProvider i18n={i18n}>
        <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={i18n.language}>
          <ErrorBoundary>
            <ConfigProvider>
              <UserManagerProvider>
                <MyRouter />
              </UserManagerProvider>
            </ConfigProvider>
          </ErrorBoundary>
        </LocalizationProvider>
      </I18nextProvider>
    </Suspense>
  </ThemeProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
